import { Component, DestroyRef, Inject, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ViewStateService } from './core/services/view-state.service';
import { FeatureFlagsService } from './core/services/feature-flags.service';

@Component({
  selector: 'app-root',
  template: require('./app.component.html').default,
  standalone: false,
})
export class AppComponent {
  currentYear = new Date().getFullYear();

  private destroyRef = inject(DestroyRef);

  constructor(
    @Inject(Router) private router: Router,
    @Inject(ViewStateService) private viewState: ViewStateService,
    @Inject(FeatureFlagsService) private featureFlags: FeatureFlagsService
  ) {
    this.featureFlags.load().pipe(takeUntilDestroyed(this.destroyRef)).subscribe();

    this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe((event) => {
        this.viewState.setLastRoute(event.urlAfterRedirects);
      });
  }
}
